import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20flowing%20golden%20and%20amber%20light%20particles%20and%20geometric%20patterns%2C%20luxurious%20warm%20atmosphere%2C%20movie%20theater%20vibe%2C%20elegant%20dark%20theme%20with%20soft%20glow%20effects%2C%20perfect%20for%20video%20streaming%20platform%20hero%20background&width=1920&height=900&seq=hero-bg-001&orientation=landscape"
          alt="BaoyuTV高清视频平台"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          畅享<strong className="text-primary-400">高清视频</strong>，精彩无处不在
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          BaoyuTV汇聚海量影视、综艺、动漫等优质内容资源，采用全球CDN加速与4K超清画质技术，
          为您带来流畅纯净的观影体验。随时随地，想看就看。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/drama"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base cursor-pointer hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索内容库
          </Link>
          <Link
            to="/article/baoyutv-xinshourumen"
            className="px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-semibold text-base cursor-pointer hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            新手指南
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { value: '5000万+', label: '月活用户' },
            { value: '10万+', label: '影视资源' },
            { value: '4K HDR', label: '超清画质' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}